import { render, staticRenderFns } from "./StatLine.vue?vue&type=template&id=c406353e&"
import script from "./StatLine.vue?vue&type=script&lang=js&"
export * from "./StatLine.vue?vue&type=script&lang=js&"
import style0 from "./StatLine.vue?vue&type=style&index=0&id=c406353e&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports